// @ts-check
import clientEnvSchema from './clientEnvSchema';

/** @typedef {import('./clientEnvSchema').ClientEnvInput} ClientEnv */

/** @type {ClientEnv} */
const clientEnvRaw = {
  NEXT_PUBLIC_VERCEL_ENV: parseVercelEnv(process.env.NEXT_PUBLIC_VERCEL_ENV),
  NEXT_PUBLIC_VERCEL_URL: process.env.NEXT_PUBLIC_VERCEL_URL,
  NEXT_PUBLIC_SITE_URL: process.env.NEXT_PUBLIC_SITE_URL,
  NEXT_PUBLIC_GOOGLE_MAPS_API_KEY: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
  NEXT_PUBLIC_DEMO_CONQUEST_PLAN_URL: process.env.NEXT_PUBLIC_DEMO_CONQUEST_PLAN_URL,
  NEXT_PUBLIC_VERCEL_DEPLOYMENT_ID: process.env.NEXT_PUBLIC_VERCEL_DEPLOYMENT_ID,
  NEXT_PUBLIC_VERCEL_SKEW_PROTECTION_ENABLED: process.env.NEXT_PUBLIC_VERCEL_SKEW_PROTECTION_ENABLED,
  NEXT_PUBLIC_PORT: process.env.NEXT_PUBLIC_PORT,
};

const clientEnv = clientEnvSchema.parse(clientEnvRaw);

export default clientEnv;

/**
 * @param {string | undefined} value
 * @returns {ClientEnv['NEXT_PUBLIC_VERCEL_ENV'] | undefined}
 */
function parseVercelEnv(value) {
  switch (value) {
    case undefined:
      return undefined;
    case 'production':
    case 'preview':
    case 'development':
    case 'demo':
      return value;
    default:
      return undefined;
  }
}
